import Header from "../Header/Header";
import PropTypes from "prop-types";
import { ErrorBox } from "@proscore-ai/proscore-ui-library";

export default function Layout({ children, status, canView = true }) {

  return (
    <>
      <Header />
      {canView ? children : <ErrorBox message="You don't have permission to view this page." />}
    </>
  );
}

Layout.propTypes = {
  children: PropTypes.node.isRequired, 
  status: PropTypes.string,          
  canView: PropTypes.bool,        
};